import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { SwitchInput } from '../../../../../../../../common/react/components/SwitchInput';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import {
    leaderboardBettingOddsSelector,
    leaderboardDataSelector,
    leaderboardNavSelector
} from '../../../../../../store/js/modules/brownlow-tracker/leaderboard/selectors';
import { UPDATE_BETTING_ODDS } from '../../../../../../store/js/modules/brownlow-tracker/leaderboard/actions';

export const BettingOddsToggle = ({ classPrefix }) => {
    const dispatch = useDispatch();

    const nav = useSelector(leaderboardNavSelector);

    const seasons = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.list ?? []
    );

    const season = seasons.find((item) => item.id === nav.season.id);
    const seasonPid = season?.providerId ?? '';

    const bettingOdds = useSelector(leaderboardBettingOddsSelector);
    const leaderboardData = useSelector((state) =>
        leaderboardDataSelector(state, seasonPid)
    );

    const status = leaderboardData?.status
        ? PULSE.app.common.match.getMatchStatus(leaderboardData.status)
        : '';

    if (
        !bettingOdds?.data?.displayInApp ||
        !bettingOdds?.data?.outcomes.length
    ) {
        return <></>;
    }

    if (
        status &&
        status === PULSE.app.common.CONSTANTS.MATCH_STATUS.COMPLETED
    ) {
        return <></>;
    }

    if (
        !bettingOdds?.data?.displayInApp ||
        !bettingOdds?.data?.outcomes.length
    ) {
        return <></>;
    }

    return (
        <div className={`${classPrefix}-nav__betting-odds-toggle`}>
            <img
                className="icon"
                src={`/resources/${window.RESOURCES_VERSION}/i/elements/sports-bet-mini.png`}
            />

            <SwitchInput
                id="brownlow-tracker-betting-odds-toggle"
                label={getTranslation(
                    'label.brownlow.bettingOdds.toggle'
                ).toUpperCase()}
                isChecked={bettingOdds.isActive}
                onChange={(isActive) =>
                    dispatch(UPDATE_BETTING_ODDS.request({ isActive }))
                }
            />
        </div>
    );
};

BettingOddsToggle.propTypes = {
    classPrefix: PropTypes.string
};
